import { render } from "./SelectPublicos.vue?vue&type=template&id=06cdd54c&scoped=true"
import script from "./SelectPublicos.vue?vue&type=script&lang=js"
export * from "./SelectPublicos.vue?vue&type=script&lang=js"

import "./SelectPublicos.vue?vue&type=style&index=0&id=06cdd54c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cdd54c"]])

export default __exports__